export default {
	riskManagement: 'Riskihaldus',
	tabs: {
		riskManagement: 'Riskihaldus',
		riskSettings: 'Riskiseaded',
		threats: 'Ohud',
		vulnerabilities: 'Nõrkused',
	},
	code: 'Kood',
	name: 'Nimetus',
	probability: 'Tõenäosus',
	impact: 'Mõju',
	score: {
		label: 'Riskiskoor',
		veryLow: 'Väga madal',
		low: 'Madal',
		medium: 'Keskmine',
		high: 'Kõrge',
		veryHigh: 'Väga kõrge',
	},
	riskMatrix: 'Riskimaatriks',
	riskOwner: 'Riskiomanik',
	residualRiskScore: 'Jääkriski skoor',
	cia: 'CIA',
	riskTreatment: 'Riskikäsitlus',
	dueDate: 'Tähtaeg',
	description: 'Kirjeldus',
	info: 'Info',
	risk: 'Risk | Riskid | Riski',
	vulnerability: 'Nõrkus | Nõrkused',
	threat: 'Oht | Ohud',
	mitigationMeasure: 'Leevendusmeede | Leevendusmeetmed',
	impactedAsset: 'Mõjutatud vara | Mõjutatud varad',
	filterAsset: 'Vajutage, et suunduda varadelehele',
	summary: 'Kokku',
	category: 'Kategooria | Kategooriad',
	impactArea: 'Mõjuala',
	physicalDamage: 'Füüsiline kahju',
	lastReview: 'Viimane kontroll',
	catalog: 'Kataloog | Kataloogid',
	user: 'Kasutaja',
	riskDecision: 'Riskiotsus | Riskiotsused',
	decision: 'Otsus',
	date: 'Kuupäev',
	asset: 'Vara | Varad',
	assetAssociation: 'Vara seos | Vara seosed',
	responsible: 'Vastutaja | Vastutajad',
	owner: 'Omanik | Omanikud',
	price: 'Hind',
	priority: 'Prioriteet',
	measuresImplemented: 'Meetmete rakendatus',
	colors: 'Värvid',
	acceptable: 'Aktsepteeritav riskitase',
	acceptableAchieved: 'Jääkrisk on alla aksepteeritava riskitaseme',
	acceptableAchievedEvent: 'Risk on saavutanud aktsepteeritud jääkriskitaseme, hinnake riskikäsitlust uuesti.',
	treatment: {
		unscored: 'Hindamata',
		preserve: 'Säilita',
		share: 'Jaga',
		reduce: 'Vähenda',
		avoid: 'Väldi',
		exclude: 'Välista',
	},
	residual: 'Jääkrisk',
	custom: 'Kohandatud',
	riskDescription: 'Riski kirjeldus',
	mitigation: {
		willNotImplement: 'Meede ei rakendu',
		addConnections: 'Meetme rakendumiseks tuleb luua seosed äriprotsessi ja mooduliga või tõsta kaitsetarbe taset',
		filter: 'Vajutage, et suunduda meetmetelehele',
		active: 'Aktiivsed meetmed',
		total: 'Koguarv',
		assetModuleRemoved: 'Mooduli seos varaga on eemaldatud',
	},
	overview: {
		label: 'Riskide ülevaade',
		approaching: 'Lähenevad tähtajad',
		criticalAssets: 'Kriitilised varad',
		criticalMethods: 'Kriitilised meetmed',
		highRiskScore: 'Kõrge jääkriskiskoor',
		importantChanges: 'Olulised muudatused',
		total: 'Riske kokku',
		overAcceptable: 'Üle aksepteeritava riskitaseme',
		unscored: 'Hindamata riske',
		overDeadline: 'Üle tähtaja',
		residualAchieved: 'Jääkrisk saavutatud',
		underAcceptable: 'Alla aksepteeritava riskitaseme',
		lastReview: 'Viimasest kontrollist möödunud aasta',
		openInstance: 'Ava asutuse riskihaldus',
		methodsText: 'Rakendatud meetmed/Kõik meetmed',
		responsibleDeadlines: 'Tähtajad kasutajate kaupa',
	},
	count: 'Seotud riskid',
	addingDisabled: 'Enne uute lisamist peate aktiveerima kataloogi!',
	manualChange: 'Aksepteeritavat riskitaset on käsitsi muudetud',
	evaluateManually: 'Hinda manuaalselt',
	resetToAuto: 'Lähtesta automaatsele arvutusele',
	manualResidualTag: 'Manuaalne',
	addNewMeta: 'Lisa uus riskiseos',
	default: 'Põhiseos',
	connection: 'Riskiseosed | Seosed',
	editConnection: 'Muuda seoseid',
	objectConnection: 'Varapõhised seosed',
	confirmDelete: 'Kas olete kindel, et soovite seda kustutada? Viimase riskiseose kustutamine kustutab kogu riski.',
}
